import {useEffect, useRef, useState} from 'react';
import {getScrollTop, getWindowHeight, getScrollHeight} from '@/utils/dom';

// 判断是否滚动到底部
export const useBottom = (callback?: (...args: any[]) => unknown, options?: {
    // 滚动距离
    distance?: number;
}) => {
    const {distance = 0} = options || {};
    const [isBottom, setIsBottom] = useState(false);
    const preValue = useRef(false);

    const onScrollHandle = () => {
        const scrollTop = getScrollTop();
        const windowHeight = getWindowHeight();
        const scrollHeight = getScrollHeight();
        setIsBottom(scrollTop + windowHeight + distance >= scrollHeight);
    };

    useEffect(
        () => {
            window.addEventListener('scroll', onScrollHandle);
            return () => {
                window.removeEventListener('scroll', onScrollHandle);
            };
        },
        []
    );

    useEffect(
        () => {
            if (isBottom !== preValue.current && isBottom) {
                callback && callback();
            }
            preValue.current = isBottom;
        },
        [callback, isBottom]
    );

    return [isBottom];
};
